import { render, staticRenderFns } from "./AddUpdateCoupons.vue?vue&type=template&id=2aab7d8a&scoped=true"
import script from "./AddUpdateCoupons.vue?vue&type=script&lang=js"
export * from "./AddUpdateCoupons.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateCoupons.vue?vue&type=style&index=0&id=2aab7d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aab7d8a",
  null
  
)

export default component.exports